import "./ComponentStyles/Resources.css";

function Resources(props) {

    window.addEventListener('load', function() {
        const iframe = document.getElementById('google-form-iframe');
        // When the window has finished loading, attach an onload event listener to the iframe
        iframe.onload = function() {
          // The form has been submitted
          iframe.style.height = "300px";
        };
    });

    return (
        <div id="resources-container">
        <h1> IEEE 3D Printing Form </h1>
        <iframe
            id="google-form-iframe"
            title="printing-google-form"
            src="https://docs.google.com/forms/d/e/1FAIpQLSf6p9oozoxzXr7-J6ZPlXimmaItrRFkE34Gk9CdTL4lCnQUOQ/viewform?embedded=true"
            width="750"
            height="1800"
            frameBorder="0"
        >
            Loading…
        </iframe>
        </div>
    );
}

export default Resources;
